module.exports = __webpack_public_path__ + "images/img-11.b794697d.jpg";